import React from 'react';
import { Card, CardContent } from './ui/card';

const CARDS = [
  { key: 'total', label: 'Total', color: 'text-foreground', bgClass: 'bg-card' },
  { key: 'green', label: 'On Track', color: 'text-[hsl(var(--rag-green))]', bgClass: 'bg-[hsl(var(--rag-green-bg))]' },
  { key: 'amber', label: 'Caution', color: 'text-[hsl(var(--rag-amber))]', bgClass: 'bg-[hsl(var(--rag-amber-bg))]' },
  { key: 'red', label: 'At Risk', color: 'text-[hsl(var(--rag-red))]', bgClass: 'bg-[hsl(var(--rag-red-bg))]' },
  { key: 'blue', label: 'Not Started', color: 'text-[hsl(var(--rag-blue))]', bgClass: 'bg-[hsl(var(--rag-blue-bg))]' },
];

export function SummaryCards({ summary = {} }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
      {CARDS.map((c) => (
        <Card key={c.key} className={`${c.bgClass} border shadow-sm`} data-testid={`summary-card-${c.key}`}>
          <CardContent className="p-4">
            <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider">{c.label}</p>
            <p className={`font-heading text-2xl font-bold tracking-tight mt-1 ${c.color}`}>
              {summary[c.key] ?? 0}
            </p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
